import styled from 'styled-components'
import query from 'syf-component-library/const/mediaQueries'
import CLButton from 'syf-component-library/ui/atoms/Button/Button'
import {
  fontSizes,
  fontWeights,
  spacing
} from 'syf-component-library/defaultTheme'

export const LWSErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.white};
  width: 758px;
  margin: ${spacing.xxlarge}px auto;
  padding: ${spacing.large}px 56px;
  border-radius: 10px;
  @media ${query.lessThanMedium} {
    width: 343px;
    padding: ${spacing.large}px;
    margin: ${spacing.base}px auto;
  }
`

export const ErrorImage = styled.img`
  width: 216px;
  height: 144px;
  @media ${query.lessThanMedium} {
    width: 168px;
    height: 112px;
  }
`

export const ErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.base}px;
  padding: 0 0 ${spacing.small}px 0;
  margin: ${spacing.large}px 0;
  @media ${query.lessThanMedium} {
    gap: ${spacing.medium}px;
    padding: 0 0 ${spacing.base}px 0;
    margin: ${spacing.small}px 0 ${spacing.base}px 0;
  }
`

export const ErrorTitle = styled.p`
  font-size: ${fontSizes.large}px;
  font-weight: ${fontWeights.bold};
  @media ${query.lessThanMedium} {
    font-size: ${fontSizes.medium}px;
    text-align: center;
  }
`

export const ErrorMessage = styled.p`
  font-size: ${fontSizes.root}px;
  font-weight: ${fontWeights.regular};
  text-align: center;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base}px;
`

const BaseButtonLegacy = styled(CLButton)`
  height: 48px;
  padding: ${spacing.medium}px ${spacing.large}px;
  background-color: ${({ theme }) => theme.cyanBlue};
  font-size: ${fontSizes.smallPlus}px;
  font-weight: ${fontWeights.bold};
  margin: 0;
  @media ${query.lessThanMedium} {
    height: auto;
    min-height: 48px;
  }
`

export const SignInLegacy = styled(BaseButtonLegacy)`
  color: ${({ theme }) => theme.white};
`

export const GoBackLegacy = styled(BaseButtonLegacy)`
  background-color: ${({ theme }) => theme.white};
  border: 2px solid ${({ theme }) => theme.cyanBlue};
  color: ${({ theme }) => theme.cyanBlue};
`
